import { Button, List, ListItem, Typography } from '@mui/material'
import { locations } from 'constant'
import { OrderContext } from 'contexts/OrderContextProvider'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

const PickLocation = () => {
  const navigate = useNavigate()
  const { setSelectedLocationId } = useContext(OrderContext)

  return (
    <>
      <Button
        variant='outlined'
        onClick={() => {
          navigate(-1)
        }}
        sx={{
          margin: '20px'
        }}
      >
        Back
      </Button>
      <Typography variant='h3' sx={{ textAlign: 'center' }}>
        Pick a Location
      </Typography>
      <List
        sx={{
          '& .MuiListItemButton-root': {
            color: '#607998',
            fontFamily: 'sans-serif',
            fontWeight: 600
          },
          '& a': {
            textDecoration: 'none'
          }
        }}
      >
        {locations.map(location => (
          <ListItem key={location.id}>
            <Button
              variant='contained'
              sx={{
                width: '100%',
                textAlign: 'center',
                textTransform: 'none',
                fontSize: '26px',
                padding: '50px 20px',
                backgroundColor: '#364c63',
                marginBottom: '20px'
              }}
              onClick={() => {
                setSelectedLocationId(location.id)
              }}
            >
              {location.value}
            </Button>
          </ListItem>
        ))}
      </List>
    </>
  )
}

export default PickLocation
